import { c as _c } from "react/compiler-runtime";
import React from 'react';
// import { RemoveScroll } from 'shared/react-remove-scroll';
import { FloatingFocusManager, FloatingOverlay, useClick, useFloating, useId, useInteractions, useRole } from '@floating-ui/react';
import { RemoveScrollBar, zeroRightClassName } from 'react-remove-scroll-bar';
import { Transition } from 'react-transition-group';
import { Box, BoxProps } from 'shared/grid';
import { usePreviousIfFalsy } from 'shared/hooks';
import Portal from '../portal';
import Toaster from '../toaster';
import { ModalContext, ModalToastContext } from './context';
import { useMediaPredicate as useMedia } from '../hooks/use-media';
import { Theme, ThemeContext } from '@emotion/react';
const modalZIndex = 6002;
const duration = 100;
const defaultStyle = {
  opacity: 0,
  // transform: 'translate3d(0, 0, 0)',
  // transition: `opacity ${duration}ms ease-out, transform ${duration}ms ease-out`,
  transition: `opacity ${duration}ms ease-out`
};
const transitionStyles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
export interface ModalWindowProps extends BoxProps {
  size?: 'tiny' | 'small' | 'medium' | 'large' | 'xlarge' | 'full' | 'left' | 'right' | 'minimized';
  sizeOptions?: ModalWindowProps['size'][];
  className?: string;
  close: any;
  style?: React.CSSProperties;
  children: any;
}
function ModalWindow(t0) {
  const $ = _c(37);
  let children;
  let close;
  let ref;
  let rest;
  let size;
  let style;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      ref,
      size,
      className: t1,
      close,
      style,
      children,
      sx,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = close;
    $[3] = ref;
    $[4] = rest;
    $[5] = size;
    $[6] = style;
    $[7] = sx;
    $[8] = t1;
  } else {
    children = $[1];
    close = $[2];
    ref = $[3];
    rest = $[4];
    size = $[5];
    style = $[6];
    sx = $[7];
    t1 = $[8];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[9] !== close) {
    t2 = e => {
      if (e.keyCode === 27) {
        close();
        e.stopPropagation();
      }
    };
    $[9] = close;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleKeyDown = t2;
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      tiny: 324,
      small: 540,
      medium: 600,
      large: 972,
      xlarge: 1260,
      full: "100%",
      left: 460,
      right: 460,
      minimized: 300
    };
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const modalWidthMap = t3;
  const modalWidth = modalWidthMap[size] ?? 600;
  const t4 = `modal ${className || ""}`;
  const t5 = typeof modalWidth == "number" ? `${modalWidth}px` : modalWidth;
  const t6 = typeof modalWidth == "number" ? `${modalWidth}px` : modalWidth;
  let t7;
  if ($[12] !== modalWidth || $[13] !== size) {
    t7 = size === "left" ? {
      top: 0,
      left: "var(--left-menu-panel-width, 0px)",
      bottom: 0,
      width: modalWidth,
      height: "100%",
      minHeight: "100dvh",
      marginLeft: 0,
      borderRadius: 0
    } : {};
    $[12] = modalWidth;
    $[13] = size;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t10;
  let t8;
  let t9;
  if ($[15] !== size) {
    t8 = size === "right" ? {
      top: 0,
      right: 0,
      bottom: 0,
      height: "100%",
      minHeight: "100dvh",
      marginRight: 0,
      borderRadius: 0
    } : {};
    t9 = size === "minimized" ? {
      bottom: 0,
      width: "300px",
      maxWidth: "none",
      height: "100%",
      minHeight: "100dvh",
      borderRadius: 0,
      left: "-9000px",
      display: "none"
    } : {};
    t10 = size === "full" ? {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: "100%",
      maxWidth: "none",
      height: "100%",
      minHeight: "100dvh",
      marginLeft: 0,
      border: 0,
      borderRadius: 0,
      marginY: 0
    } : {};
    $[15] = size;
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t11;
  if ($[19] !== sx) {
    t11 = sx || {};
    $[19] = sx;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t12 = {
      containerType: "inline-size",
      zIndex: modalZIndex + 1,
      backfaceVisibility: "hidden",
      padding: 0,
      border: 0,
      borderRadius: 2,
      outline: "none",
      boxShadow: "extraLarge",
      overflowY: "visible",
      height: "auto",
      position: "relative",
      marginRight: "auto",
      marginLeft: "auto",
      minHeight: 0,
      maxWidth: t5,
      flexBasis: t6,
      ...t7,
      ...t8,
      ...t9,
      ...t10,
      ...t11
    };
    $[21] = t10;
    $[22] = t11;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== children || $[30] !== handleKeyDown || $[31] !== ref || $[32] !== rest || $[33] !== style || $[34] !== t12 || $[35] !== t4) {
    t13 = <Box {...rest} role="dialog" aria-modal="true" ref={ref} onKeyDown={handleKeyDown} tabIndex={0} className={t4} style={style} backgroundColor="background" sx={t12}>{children}</Box>;
    $[29] = children;
    $[30] = handleKeyDown;
    $[31] = ref;
    $[32] = rest;
    $[33] = style;
    $[34] = t12;
    $[35] = t4;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}
export interface ModalProps<T = any> extends Omit<BoxProps, 'children'> {
  usePortal?: boolean;
  isOpen: boolean;
  close?: () => any;
  children: (props?: T & {
    close: () => void;
    backdropRef: any;
  }) => React.JSX.Element;
  autoFocus?: boolean;
  className?: string;
  noShrink?: boolean;
  props?: any;
  zIndexDelta?: number;
  backdropRef?: React.RefObject<HTMLDivElement>;
  size?: ModalWindowProps['size'];
  changeSize?: (size: ModalWindowProps['size']) => void;
  sizeOptions?: ModalWindowProps['size'][];
}
const Modal = React.memo(function Modal(t0) {
  const $ = _c(74);
  let backdropRef;
  let children;
  let close;
  let isOpen;
  let props;
  let rest;
  let sizeOptions;
  let sx;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t0) {
    ({
      usePortal: t1,
      isOpen,
      close,
      children,
      autoFocus: t2,
      className: t3,
      noShrink: t4,
      size: t5,
      sizeOptions,
      props,
      zIndexDelta: t6,
      backdropRef,
      changeSize: t7,
      sx,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = backdropRef;
    $[2] = children;
    $[3] = close;
    $[4] = isOpen;
    $[5] = props;
    $[6] = rest;
    $[7] = sizeOptions;
    $[8] = sx;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    backdropRef = $[1];
    children = $[2];
    close = $[3];
    isOpen = $[4];
    props = $[5];
    rest = $[6];
    sizeOptions = $[7];
    sx = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  const usePortal = t1 === undefined ? true : t1;
  const autoFocus = t2 === undefined ? true : t2;
  const className = t3 === undefined ? "" : t3;
  t4 === undefined ? false : t4;
  const requestedSize = t5 === undefined ? null : t5;
  const modalZIndexDelta = t6 === undefined ? 0 : t6;
  const changeSize = t7 === undefined ? null : t7;
  let t8;
  if ($[16] !== changeSize || $[17] !== requestedSize || $[18] !== sizeOptions) {
    t8 = {
      size: requestedSize,
      changeSize,
      sizeOptions
    };
    $[16] = changeSize;
    $[17] = requestedSize;
    $[18] = sizeOptions;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const modalCtx = t8;
  const defaultBackdropRef = React.useRef(null);
  const modalBackdropRef = backdropRef || defaultBackdropRef;
  const clickStartedOnOverlayRef = React.useRef(false);
  const ctx = React.useContext(ModalToastContext);
  const [viewPortOverlaySize, setViewPortOverlaySize] = React.useState(0);
  const pendingUpdateRef = React.useRef(false);
  let t10;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const viewportHandler = function viewportHandler(event) {
        if (pendingUpdateRef.current) {
          return;
        }
        pendingUpdateRef.current = true;
        requestAnimationFrame(() => {
          pendingUpdateRef.current = false;
          const viewport = event.target;
          setViewPortOverlaySize(window.innerHeight - viewport.height);
        });
      };
      window.visualViewport?.addEventListener?.("resize", viewportHandler);
      return () => {
        window.visualViewport?.removeEventListener?.("resize", viewportHandler);
      };
    };
    t10 = [];
    $[20] = t10;
    $[21] = t9;
  } else {
    t10 = $[20];
    t9 = $[21];
  }
  React.useEffect(t9, t10);
  let t11;
  if ($[22] !== close) {
    t11 = () => {
      if (close) {
        close();
        clickStartedOnOverlayRef.current = false;
      }
    };
    $[22] = close;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const closeFn = t11;
  let t12;
  if ($[24] !== closeFn || $[25] !== isOpen) {
    t12 = {
      open: isOpen,
      onOpenChange: closeFn
    };
    $[24] = closeFn;
    $[25] = isOpen;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const {
    context
  } = useFloating(t12);
  const modalRef = React.useRef(null);
  const id = useId();
  const labelId = `${id}-label`;
  const descriptionId = `${id}-description`;
  const t13 = useClick(context);
  const t14 = useRole(context);
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = [t13, t14];
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const {
    getFloatingProps
  } = useInteractions(t15);
  const setModalCount = ctx.setModalCount;
  let t16;
  let t17;
  if ($[30] !== isOpen || $[31] !== setModalCount) {
    t16 = () => {
      if (!isOpen) {
        return;
      }
      const delta = isOpen ? 1 : 0;
      setModalCount(c => c + delta);
      return () => {
        setModalCount(c_0 => c_0 - delta);
      };
    };
    t17 = [setModalCount, isOpen];
    $[30] = isOpen;
    $[31] = setModalCount;
    $[32] = t16;
    $[33] = t17;
  } else {
    t16 = $[32];
    t17 = $[33];
  }
  React.useEffect(t16, t17);
  let t18;
  if ($[34] !== autoFocus) {
    t18 = () => {
      if (autoFocus && modalRef.current) {
        const focusableEls = modalRef.current.querySelectorAll("input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex=\"-1\"])");
        let focusableEl;
        for (const el of focusableEls) {
          if (window.getComputedStyle(el).display !== "none") {
            focusableEl = el;
            break;
          }
        }
        if (!focusableEl) {
          focusableEl = modalRef.current.querySelector("a[href], area[href], button:not(.close):not(.popover)") as HTMLElement;
        }
        focusableEl?.focus?.();
      }
    };
    $[34] = autoFocus;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const focus = t18;
  const isOpenBool = !!isOpen;
  const lastOpenValueRef = React.useRef(isOpenBool);
  let t19;
  let t20;
  if ($[36] !== focus || $[37] !== isOpenBool) {
    t19 = () => {
      if (lastOpenValueRef.current == isOpenBool) {
        return;
      }
      if (isOpenBool) {
        setTimeout(focus);
      }
      lastOpenValueRef.current = isOpenBool;
    };
    t20 = [isOpenBool, focus];
    $[36] = focus;
    $[37] = isOpenBool;
    $[38] = t19;
    $[39] = t20;
  } else {
    t19 = $[38];
    t20 = $[39];
  }
  React.useEffect(t19, t20);
  const oldProps = usePreviousIfFalsy(props, !isOpen, duration);
  const theme = React.useContext(ThemeContext);
  const isXLarge = useMedia(theme.mediaQueries.xLargeUp);
  const {
    hasRightPanel,
    hasLeftPanel
  } = ctx;
  const isRightSidePanelTakingSpace = hasRightPanel && isXLarge;
  const isLeftSidePanelTakingSpace = hasLeftPanel && isXLarge;
  const size = !isXLarge && ["right", "left"].includes(requestedSize) ? "large" : requestedSize;
  const MaybePortal = usePortal ? Portal : React.Fragment;
  const t21 = !!isOpen;
  let t22;
  if ($[40] !== changeSize || $[41] !== children || $[42] !== className || $[43] !== close || $[44] !== closeFn || $[45] !== context || $[46] !== descriptionId || $[47] !== getFloatingProps || $[48] !== isLeftSidePanelTakingSpace || $[49] !== isOpen || $[50] !== isRightSidePanelTakingSpace || $[51] !== labelId || $[52] !== modalBackdropRef || $[53] !== modalZIndexDelta || $[54] !== oldProps || $[55] !== props || $[56] !== rest || $[57] !== size || $[58] !== sx || $[59] !== viewPortOverlaySize) {
    t22 = state => state !== "exited" && state !== "unmounted" && <>{!["minimized", "left", "right"].includes(size) && <RemoveScrollBar />}<Box as={FloatingOverlay} style={{
        ...defaultStyle,
        ...transitionStyles[state],
        top: 0,
        right: isRightSidePanelTakingSpace && size !== "right" ? 460 : 0,
        left: isLeftSidePanelTakingSpace && size !== "left" ? "calc(460px + var(--left-menu-panel-width, 0px))" : 0,
        bottom: 0
      }} ref={modalBackdropRef} className="modal-overlay" role="dialog" onClick={event_0 => {
        if (clickStartedOnOverlayRef.current && modalBackdropRef.current === event_0.target) {
          closeFn();
        }
        clickStartedOnOverlayRef.current = false;
      }} onMouseDown={event_1 => {
        if (modalBackdropRef.current === event_1.target) {
          clickStartedOnOverlayRef.current = true;
        }
      }} sx={{
        contain: "content",
        position: "fixed",
        zIndex: modalZIndex + modalZIndexDelta,
        backgroundColor: "rgba(0, 0, 0, 0.45)",
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        overflowX: "hidden",
        overscrollBehavior: "contain",
        "--top-bar-height": "0px",
        pb: viewPortOverlaySize,
        ...(size === "left" || size === "right" || size === "minimized" ? {
          pointerEvents: "none",
          backgroundColor: "transparent"
        } : {})
      }}><Box sx={{
          pointerEvents: "none",
          transition: "transform 0.2s ease-out",
          minHeight: "100%",
          display: "flex",
          alignItems: "center"
        }} className={zeroRightClassName}><FloatingFocusManager context={context} initialFocus={-1}><ModalWindow {...rest} {...getFloatingProps()} ref={modalRef} aria-labelledby={labelId} aria-describedby={descriptionId} className={`${className} ${zeroRightClassName}`} close={closeFn} size={size} sx={{
              ...sx,
              pointerEvents: "all"
            }}>{children({
                ...((!isOpen ? oldProps : props) || {}),
                close,
                backdropRef: modalBackdropRef,
                size,
                changeSize
              })}</ModalWindow></FloatingFocusManager></Box></Box></>;
    $[40] = changeSize;
    $[41] = children;
    $[42] = className;
    $[43] = close;
    $[44] = closeFn;
    $[45] = context;
    $[46] = descriptionId;
    $[47] = getFloatingProps;
    $[48] = isLeftSidePanelTakingSpace;
    $[49] = isOpen;
    $[50] = isRightSidePanelTakingSpace;
    $[51] = labelId;
    $[52] = modalBackdropRef;
    $[53] = modalZIndexDelta;
    $[54] = oldProps;
    $[55] = props;
    $[56] = rest;
    $[57] = size;
    $[58] = sx;
    $[59] = viewPortOverlaySize;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== modalBackdropRef || $[62] !== t21 || $[63] !== t22) {
    t23 = <Transition nodeRef={modalBackdropRef} in={t21} timeout={duration}>{t22}</Transition>;
    $[61] = modalBackdropRef;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== isOpen) {
    t24 = isOpen ? <Toaster inModal={true} /> : null;
    $[65] = isOpen;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== MaybePortal || $[68] !== t23 || $[69] !== t24) {
    t25 = <MaybePortal>{t23}{t24}</MaybePortal>;
    $[67] = MaybePortal;
    $[68] = t23;
    $[69] = t24;
    $[70] = t25;
  } else {
    t25 = $[70];
  }
  let t26;
  if ($[71] !== modalCtx || $[72] !== t25) {
    t26 = <ModalContext.Provider value={modalCtx}>{t25}</ModalContext.Provider>;
    $[71] = modalCtx;
    $[72] = t25;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  return t26;
});
export default Modal;